var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlueInfoIcon = function SvgBlueInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.582 0 0 3.896 0 8.703c0 4.807 3.582 8.703 8 8.703s8-3.896 8-8.703C16 3.896 12.418 0 8 0Z",
    fill: "#EAF0FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.943c-.466 0-.844.411-.844.918 0 .507.378.918.844.918.466 0 .844-.41.844-.918 0-.507-.378-.918-.844-.918Z",
    fill: "#276EF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 13.123V7.615",
    stroke: "#276EF1",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgBlueInfoIcon;